import { create } from 'zustand';
import { AccountApi, ApiUtils, RequestStrategyEnum, UploadCreditFormRequest } from '@shared/api';

interface IUploadCreditFormStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  uploadCreditForm: (request: UploadCreditFormRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useUploadCreditFormStore = create<IUploadCreditFormStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  uploadCreditForm: ApiUtils.wrapperApi(async (request: UploadCreditFormRequest, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await AccountApi.uploadCreditForm(request, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
